<script lang="ts">
  import { onMount } from 'svelte';
  import Router, { push, link } from "svelte-spa-router";
  import { location } from "./framework/js/spaLocation";
  import { writable, get } from 'svelte/store';

  import { toast } from "./framework/js/toast.js";
  import { dropdown } from './framework/js/dropdown.js';
  import { auth, userInitials, userProfileImageUrl } from "./framework/js/auth.js";
  import { api } from "./framework/js/api.js";
  import { BriefTitle } from "./stores/BriefTitleStore.js";

  import { routes } from "./js/routes.js";
  import Profile from './framework/components/Profile.svelte';
  import './framework/js/teamBillingStore.js';

  let displayProfile: boolean = false;
  
  function getBriefIdFromLocation(): string | null {
    const path = $location;
    const match = path.match(/\/brief\/([^\/]+)/);
    return match ? match[1] : null;
  }
  
  function handleCloseBrief() {
    const briefId = getBriefIdFromLocation();
    const isGuestRoute = $location.includes('/guest-brief');
    const isGuestBriefNew = $location.includes('/guest-brief-new');
    
    // For guest users on guest-brief routes, go to home/login
    if ((isGuestRoute || isGuestBriefNew) && !authData.token) {
      push('/');
      return;
    }
    
    if (briefId) {
      // Don't clear the step - let them resume where they left off
      push(`/briefs/${briefId}`);
    } else {
      // Only go to /briefs if user is authenticated
      if (authData.token) {
        push('/briefs');
      } else {
        push('/');
      }
    }
  }

  const initUserDropdown = (): void => {
    dropdown.init('user-icon', [
        {text: 'Settings', url: '#/profile', icon: 'cog icon'},
        {text: 'My Plan', url: '#/payment-plan', icon: 'credit card icon'},
        {text: 'Logout', url: logout, icon: 'sign out alternate icon'},
    ]);
  }

  export let authData: any = writable([]);
  auth.subscribe((data: any) => {
    authData = data;
  });

  const logout = async (): Promise<void> => {
    await auth.logout();
    toast.showNotification(get(auth).success, get(auth).message);
    if (get(auth).success) {
        push('/');
    }
  };

  const showUserDropdown = (): void => {
    initUserDropdown();
    dropdown.toggle();
  };


  // Redirect logged-in admins away from user routes - admins should only see admin dashboard
  $: if ($auth?.token && auth.userIsAdmin()) {
    const path = $location || '';
    const normalized = (path === '' || !path.startsWith('/')) ? '/' + (path || '') : path;
    const userOnlyPaths = ['/', '/home', '/dashboard', '/briefs', '/team-knowledge', '/research-library', '/learning', '/profile', '/payment-plans', '/payment-plan', '/invoices'];
    const isUserOnlyRoute = userOnlyPaths.some(p => normalized === p || normalized === p + '/' || (normalized.startsWith(p + '/') && !normalized.startsWith('/admin')));
    if (isUserOnlyRoute) {
      push('/dashboard-admin');
    }
  }

  /* using classList.add/remove don't seem to work, so resorting to this - Riz */
  window.onscroll = function(){ toAddClass() };
  function toAddClass() {
    const back = document.getElementById('backtotop');
    const nav = document.getElementById('mnav');
    if (!back && !nav) return;
    const scrolled = document.body.scrollTop > 10 || document.documentElement.scrollTop > 10;
    if (back) {
      back.className = scrolled
        ? "circular ui icon button showtitle tada"
        : "circular ui icon button showtitle";
    }
    if (nav) {
      nav.className = scrolled
        ? "ui menu borderless top fixed center on"
        : "ui menu borderless top fixed center";
    }
  }

</script>

{#if $location.includes('/guest-brief') || $location.includes('/login') || $location.includes('/signup') || $location.includes('/reset-password')}
<header id="hed">
  <div class="ui vertical">
    <nav id="mnav" class="ui menu borderless top fixed center" class:auth-nav={$location.includes('/login') || $location.includes('/signup') || $location.includes('/reset-password')}>
      <div class="ui container">
        {#if $location.includes('/guest-brief')}
          <div class="left menu" style="flex: 1; min-width: 0; overflow: hidden;">
            {#if $BriefTitle}
              <div class="item brief-title-nav">
                <i class="file text outline icon"></i>
                <span class="brief-title-text">{$BriefTitle}</span>
              </div>
            {/if}
          </div>
          <div class="right menu" style="flex-shrink: 0;">
            <a href="/#" class="back-home-button" on:click|preventDefault={handleCloseBrief}>
              <i class="arrow left icon"></i> Back to home
            </a>
          </div>
            {:else}
            <div class="right menu">
              {#if authData.token}
              <a use:link href="/learning" class="item auth-nav-link">Learning Hub</a>
              <a use:link href="/brief-new" class="item auth-nav-link">Start Brief</a>
              {:else if !$location.includes('/login') && !$location.includes('/signup') && !$location.includes('/reset-password')}
              <a use:link href="/guest-brief-new" class="auth-nav-button">
                Start Brief
                <span class="arrow">→</span>
              </a>
              {/if}
    
            {#if authData.token}
              <div class="item isbutton">
                <button
                  type="button"
                  id="user-icon"
                  class="ui circular image user-menu-trigger"
                  class:noimg={!$userProfileImageUrl}
                  on:click={showUserDropdown}
                  aria-label="Open user menu"
                  aria-haspopup="true"
                >
                  {#if $userProfileImageUrl}
                    <img src={$userProfileImageUrl} alt="" class="user-menu-avatar" />
                  {:else}
                    {$userInitials}
                  {/if}
                </button>
              </div>
            {/if}
            </div>
        {/if}
      </div>
    </nav>
  </div>
</header>
{/if}
<div class="canvas" class:admin-view={$location?.startsWith('/dashboard-admin') || $location?.startsWith('/admin/')}>
  <Router {routes}/>
  {#if ($location.includes('/brief') && !$location.includes('/briefs') && !$location.includes('/dashboard')) || $location.includes('/guest-brief') || ($location.includes('/dashboard') || $location.includes('/briefs') || $location.includes('/team-knowledge') || $location.includes('/research-library') || $location.includes('/research-plan') || $location.includes('/brand-sentiment') || $location.includes('/learning') || $location.includes('/profile'))}
    <img src="./src/assets/bg_brief.png" alt="" class="brief-bg">
  {/if}
</div>

<style>
  .user-menu-trigger {
    padding: 0;
    font: inherit;
    color: inherit;
    overflow: hidden;
  }

  .user-menu-trigger .user-menu-avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
</style>
